module.exports = __webpack_public_path__ + "img/580a.df3403fc.png";